export default "__VITE_ASSET__BVL$EVYs__"